import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterDocumentFilters,
  FilterOptionKeys,
  Goal,
  GroupByMode,
  ID,
  SortingMode,
} from '@griply/types';

export const buildGoalTaskDefaultFilter = (
  goal: Goal | undefined,
  subGoalIds: ID[],
): FilterDocument => {
  const include = [goal?.id ?? '', ...subGoalIds];
  return {
    sortingMode: SortingMode.Custom,
    groupByMode: GroupByMode.Section,
    filters: {
      [FilterOptionKeys.Goal]: {
        include,
        availableOptions: include,
      },
    },
  };
};

export const buildGoalTaskFilterDocument = (
  goal: Goal | undefined,
  subGoalIds: ID[],
): FilterDocument => {
  const base = buildGoalTaskDefaultFilter(goal, subGoalIds);

  const storedGoalFilter =
    goal?.filterDocument?.filters?.[FilterOptionKeys.Goal];
  const freshInclude = base.filters?.[FilterOptionKeys.Goal]?.include ?? [];

  let reconciledGoalFilter: FilterDocumentFilters[FilterOptionKeys.Goal] = {
    ...base.filters?.[FilterOptionKeys.Goal],
    availableOptions: freshInclude,
  };

  if (storedGoalFilter?.include) {
    const storedInclude = storedGoalFilter.include;
    const storedAvailable = storedGoalFilter.availableOptions ?? storedInclude;
    const kept = storedInclude.filter((id: ID) => freshInclude.includes(id));
    const added = freshInclude.filter(
      (id: ID) => !storedAvailable.includes(id),
    );
    reconciledGoalFilter = {
      ...storedGoalFilter,
      include: [...kept, ...added],
      availableOptions: freshInclude,
    };
  }

  return {
    ...base,
    ...(goal?.filterDocument ?? {}),
    showCompleted: !(goal?.hideCompletedTasks ?? true),
    [DocumentOrganizationKeys.Filters]: {
      ...base.filters,
      ...(goal?.filterDocument?.filters ?? {}),
      [FilterOptionKeys.Goal]: reconciledGoalFilter,
    },
  };
};
